/*=====================================================================*\
   @new
   - Keeps the PDP wishlist button variant in sync with the
     selected variant so Swym saves the variant the customer
     is actually looking at (not always the first variant)
\*=====================================================================*/

document.addEventListener('product:variant-change', (event) => {
  const { variant, sectionId } = event.detail || {};

  if (!variant || !sectionId) return;

  document
    .querySelectorAll(`product-form[data-section="${sectionId}"] .wr-product-wishlist-button[data-swaction="addToWishlist"]`)
    .forEach((button) => {
      button.setAttribute('data-variant-id', variant.id);
    });
});
